module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl3-100.f28da35a.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl3-100.png
// module id = 3360
// module chunks = 11